import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { AUTO_RESET_TIMEOUT } from '../../utils/constants';

// Logo from public folder - accessed via absolute path
const dubaiPoliceLogo = '/transparent-logo-vertical.png';

const QRCodeScreen = ({ imageUrl, onDone, onAutoReset }) => {
  const [timeRemaining, setTimeRemaining] = useState(AUTO_RESET_TIMEOUT / 1000);

  useEffect(() => {
    const autoResetTimer = setTimeout(onAutoReset, AUTO_RESET_TIMEOUT);
    const countdownInterval = setInterval(() => {
      setTimeRemaining((prev) => Math.max(prev - 1, 0));
    }, 1000);
    return () => {
      clearTimeout(autoResetTimer);
      clearInterval(countdownInterval);
    };
  }, [onAutoReset]);

  return (
    <div className="h-screen relative overflow-hidden bg-gradient-to-b from-white via-[#F6FBF9] to-[#E4EFEA]">
      {/* Vertical spine */}
      <div className="forensic-spine" />

      {/* Background layers */}
      <div className="forensic-grid-overlay opacity-15" />
      <div className="forensic-map-overlay opacity-[0.05]" />
      <div className="forensic-fingerprint-texture opacity-40" />
      <div className="forensic-circuit-lines" />

      {/* Green blocks */}
      <div className="forensic-block forensic-block-1" />
      <div className="forensic-block forensic-block-2" />
      <div className="forensic-corner-tl" />
      <div className="forensic-corner-br" />

      {/* Main content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-8 text-center gap-6">
        {/* Logo */}
        <img src={dubaiPoliceLogo} alt="Dubai Police" className="h-20 w-auto mb-3" />

        {/* Title - Bilingual inline style */}
        <h1 className="text-2xl font-bold tracking-[0.1em] uppercase text-[#1A1A1A] mb-2">
          Scan To Collect <span className="text-[#6B7770] font-arabic font-normal">| امسح للتحميل</span>
        </h1>

        {/* Subtitle */}
        <p className="text-sm text-[#6B7770] font-title-light mb-2">
          Use your mobile camera to download your AI generated image
        </p>

        {/* QR Code */}
        <div className="forensic-card p-6 shadow-lg">
          <QRCodeSVG
            value={imageUrl}
            size={320}
            level="H"
            includeMargin
            bgColor="#FFFFFF"
            fgColor="#0e734b"
          />
        </div>

        {/* Timer - Bilingual */}
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 bg-[#0e734b] rounded-sm animate-pulse" />
          <span className="text-sm uppercase tracking-[0.2em] text-[#4A5550] font-title-light">
            Session resets in <span className="text-[#1A1A1A] font-bold">{timeRemaining}s</span>
          </span>
          <span className="text-sm text-[#4A5550] font-arabic">
            — إعادة التعيين خلال
          </span>
          <div className="w-2 h-2 bg-[#0e734b] rounded-sm animate-pulse" />
        </div>

        {/* Complete button - Bilingual */}
        <button
          onClick={onDone}
          className="forensic-btn-primary px-12 py-4 text-base flex items-center gap-3"
        >
          <span className="font-title uppercase">Done</span>
          <span className="text-white/60">|</span>
          <span className="font-arabic font-bold">انتهى</span>
        </button>

      </div>
    </div>
  );
};

export default QRCodeScreen;
